/**
 * Narrator Feature Flags
 *
 * Shared constants controlling narrator experience across animation variants.
 * Extracted from LetterThrowingAnimation.web.tsx and LetterZoomAnimation.web.tsx
 * to eliminate duplication.
 */

/**
 * Feature flag: Enable narrator subtitle experience during animation
 *
 * Controls whether the narrator subtitle area is shown at all during the animation.
 * When true, loading quips appear during the emergence phase.
 *
 * @see ModernResultsFull.tsx - narrator_intro displayed on results page
 * @see ModernResultsPreview.tsx - narrator_intro displayed on results page
 */
export const NARRATOR_EXPERIENCE_ENABLED = true;
